import React from "react";
import Icon1 from "../icons/Icon";

import TFGPT1 from "./TFGPT1";

function SearchBarCarnets({
  orgData,
  options,
  value,
  setValue,
  onAction,
  searchEvents = false,
  setSeachType,
}) {
  return (
    <div
      className={`bg-white ${
        options.map((option) => option.label).includes(value)
          ? "border-2  border-blue-300"
          : "border-1 border-shadow_25"
      } rounded-3xl  w-fit px-3 py-1 h-fit`}
    >
      <div className="flex flex-row gap-2 w-full items-center">
        <Icon1 icon_name="search" fill={"grey"}></Icon1>
        <TFGPT1
          options={options}
          placeholder="Chercher"
          inputValue={value}
          setInputValue={setValue}
          onAction={onAction}
          width={400}
          start_only={false}
          has_label={true}
        ></TFGPT1>
      </div>
    </div>
  );
}

export default SearchBarCarnets;
